import { render, staticRenderFns } from "./FileTableRow.vue?vue&type=template&id=f533fb70&"
import script from "./FileTableRow.vue?vue&type=script&lang=ts&"
export * from "./FileTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports